__turbopack_context__.v({
  "btn": "AccordionText-module-scss-module__2uo9uq__btn",
  "btn_marginContent": "AccordionText-module-scss-module__2uo9uq__btn_marginContent",
  "collapse": "AccordionText-module-scss-module__2uo9uq__collapse",
  "content": "AccordionText-module-scss-module__2uo9uq__content",
});
